<template>
  <div class="food-manage">
    <div class="food-search tuolele-main-box">
      <div class="tuolele-main-search tuolele-main-search-item">
        <el-form :inline="true" :model="listQuery" class="fn-clear">
          <el-row>
            <el-form-item label="签约单号" class="fn-left">
              <el-input v-model="listQuery.order_id" />
            </el-form-item>
            <el-form-item label="商户订单号" class="fn-left">
              <el-input v-model="listQuery.out_trade_no" />
            </el-form-item>
            <el-form-item label="学员ID" class="fn-left">
              <el-input v-model="listQuery.sub_id" />
            </el-form-item>
            <el-form-item label="学员姓名" class="fn-left">
              <el-input v-model="listQuery.sub_name" />
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="选择时间" class="fn-left">
              <Select key="5" :selected.sync="listQuery.time_type" :data="timeTypeLists" clearable placeholder="请选择" />
              <el-date-picker v-model="listQuery.time" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="changeTime" />
            </el-form-item>
            <el-form-item label="订单类型" class="fn-left">
              <Select key="5" :selected.sync="listQuery.kpi_status" :data="kpiStatusLists" clearable placeholder="请选择" />
            </el-form-item>
          </el-row>
          <el-form-item label="" class="fn-left">
            <el-button type="primary" @click="fnGetOrderSignLists">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="tuolele-main-box">
      <el-table :key="tableKey" :data="lists" border stripe>
        <el-table-column label="创建时间" prop="create_time" align="center" />
        <el-table-column label="最后操作时间" prop="modify_time" align="center" />
        <el-table-column label="签约单号" prop="order_id" align="center" />
        <el-table-column label="学员ID" prop="sub_id" align="center" />
        <el-table-column label="学员姓名" prop="sub_name" align="center" />
        <el-table-column label="套餐名称" prop="item_title" align="center" />
        <el-table-column label="套餐科目" prop="subject_name" align="center" />
        <el-table-column label="套餐价格" align="center">
          <template slot-scope="{row}">
            <span>{{ row.total_price/100 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="实付金额" align="center">
          <template slot-scope="{row}">
            <span>{{ row.contract_amount/100 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单类型" prop="kpi_status_name" align="center" />
        <el-table-column label="操作">
          <template slot-scope="{row}">
            <el-button v-if="row.invoice_status != 0" type="text" @click="fnLookInvoice(row.order_id)">查看发票</el-button>
            <el-button v-if="row.invoice_status == 0" type="text" @click="fnEditInvoice(row.order_id)">编辑发票</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="footer pagination-footer" style="text-align: center;">
      <el-pagination layout="prev, pager, next, slot, jumper" :current-page.sync="listQuery.p" prev-text="上一页" next-text="下一页" :total="listQuery.total" :page-size="listQuery.limit" @current-change="fnGetOrderSignLists" />
    </div>
    <el-dialog title="发票信息" :visible.sync="bShowInvoiceDialog">
      <el-form ref="invoicePostForm" :model="invoicePostForm">
        <el-form-item label="类型" prop="point">
          <el-radio-group v-model="invoicePostForm.invoice_type">
            <el-radio label="1">增值税普票</el-radio>
            <el-radio label="2">增值税专票</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="发票号">
          <el-input v-model="invoicePostForm.invoice_no" placeholder="请填入发票号" />
        </el-form-item>
      </el-form>
      <span v-if="invoicePostForm.dialogStatus == 'create'" slot="footer" class="dialog-footer">
        <el-button type="primary" @click="fnSubmitInvoice()">确 定</el-button>
      </span>
    </el-dialog>
  </div>

</template>
<script>

import Select from '@/components/Select'
import commondata from '@/utils/commondata'
// import { validateRequire } from '@/utils/validate'

// import Tool from '@/assets/js/tool.js'

const defaultInvoicePostForm = {
  order_id: '',
  invoice_type: '1',
  invoice_no: '',
  dialogStatus: 'create'
}

export default {
  name: 'TyyKnowledgeSettingLists',
  components: {
    Select
  },
  data() {
    return {
      lists: [],
      tableKey: 0,
      listQuery: {
        p: 1,
        limit: 20,
        order_id: '',
        begin_date: '',
        end_date: '',
        total: 0,
        time: '',
        sub_id: '',
        sub_name: '',
        time_type: '',
        kpi_status: '',
        out_trade_no: ''
      },
      invoicePostForm: Object.assign({}, defaultInvoicePostForm),
      packageTypes: commondata.TYY_PACKAGE_TYPE,
      timeTypeLists: commondata.TYY_TIME_TYPE,
      kpiStatusLists: commondata.KPI_STATUS,
      bShowInvoiceDialog: false
    }
  },
  created() {
    this.fnGetOrderSignLists()
  },
  methods: {
    fnGetOrderSignLists: function() {
      this.bShowInvoiceDialog = false
      this.$http.tyyGetTyyOrderList(this.listQuery).then(res => {
        this.listQuery.total = parseInt(res.data.count)
        this.lists = res.data.list
      })
    },
    fnLookInvoice: function(order_id) {
      this.invoicePostForm.order_id = order_id
      this.invoicePostForm.dialogStatus = 'detail'
      this.$http.tyyGetInvoice({ order_id }).then(res => {
        this.invoicePostForm.invoice_no = res.data.invoice_no
        this.invoicePostForm.invoice_type = res.data.invoice_type == '0' ? '1' : res.data.invoice_type
        this.bShowInvoiceDialog = true
      })
    },
    fnEditInvoice: function(order_id) {
      this.invoicePostForm.order_id = order_id
      this.invoicePostForm.dialogStatus = 'create'
      this.invoicePostForm.invoice_no = ''
      this.invoicePostForm.invoice_type = '1'
      this.bShowInvoiceDialog = true
    },
    fnSubmitInvoice: function() {
      if (!this.invoicePostForm.invoice_no) {
        this.$message.error('请填写发票单号')
        return
      }
      this.$http.tyySetInvoice(this.invoicePostForm).then(res => {
        this.invoicePostForm.invoice_type = '1'
        this.invoicePostForm.invoice_no = ''
        this.$message.success('提交成功')
        this.fnGetOrderSignLists()
      })
    },
    changeTime: function(val) {
      if (val != null) {
        this.listQuery.begin_date = val[0]
        this.listQuery.end_date = val[1]
      } else {
        this.listQuery.begin_date = ''
        this.listQuery.end_date = ''
        this.listQuery.time = []
      }
    }
  }
}
</script>
<style lang="scss">
  .food-search {
  .tuolele-main-search-item {
    margin-bottom: 0;
    padding: 0;
    border: 0;
    .el-form--inline .el-form-item {
      display: block;
    }
    .split-time{
      margin-right: 20px;
    }
    .el-select,
    .el-input {
      width: 160px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 10px;
    }
    .button-group {
      margin-left: 82px;
    }
  }
}
</style>
